import { VOLTA_CHAIN_ID } from 'iam-client-lib';

export const ChainId = {
  Volta: VOLTA_CHAIN_ID,
  VoltaHex: '0x12047',
  EWC: 246,
  EwcHex: '0xF6',
};
